import type {
  ConveyedPersonAction,
  PersonInvolvement,
} from "../types/involvement.js";
import { isPersonUnallocated } from "./isPersonUnallocated.js";

/**
 * Allocating a responsible user is for an unallocated person. Once one is
 * allocated, handing the case on is their `assign`, so the organisation that
 * created the person's record stays out of it, and an access view must not
 * report allocating either.
 */
export const personActionsNarrowedByAllocation = (
  actions: readonly ConveyedPersonAction[],
  involvements: readonly Pick<
    PersonInvolvement,
    "kind" | "endedAt" | "expiresAt"
  >[],
  now: Date = new Date(),
): ConveyedPersonAction[] =>
  isPersonUnallocated(involvements, now)
    ? [...actions]
    : actions.filter((action) => action !== "allocate_responsible_user");
